<template>
  <div>
    <ak-model-filter-card model="frameworkUser" @search="search" @reset="reset" :filters="filters" />
    <a-spin :spinning="false" class="p-x-8">
      <ak-model-tree
        class="m-t-20"
        ref="frameworkTree"
        model="frameworkUser"
        treeModel="frameworkTree"
        pointerToTree="framework"
        :multiple="false"
        :treeSpan="5"
        @selected="select"
        parentKey="parentNode"
        rootName="天能电池集团"
        :modelTableProps="{filters, department}"
      />
    </a-spin>
  </div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
      loading: false,
      showLine: true,
      showIcon: false,
      department: {},
      action: {
        create: false
      },
      filters: {
        adminRole: 'staff'
      }, // 搜索条件
      roleList: [], // 角色列表
      departmentNumber: 0, // 部门数量
      departmentList: [] // 部门列表
    }
  },
  beforeDestroy () {
    this.$store.commit('setDepartment', null)
  },
  mounted () {
    // console.log(this.$store.state.user)
    // console.log(this.$refs.frameworkTree.getModelTable())
  },
  methods: {
    search (filters) {
      this.filters = {
        ...{
          adminRole: 'staff'
        },
        ...filters
      }
      this.$refs.frameworkTree.refresh()
    },
    reset () {
      this.filters = {
        adminRole: 'staff'
      }
      this.$refs.frameworkTree.refresh()
    },
    select (data) {
      this.$refs.frameworkTree.getModelTable().reset()

      if (data.length && data[0].parentNode) {
        this.$store.commit('setDepartment', {
          parentNode: data[0].parentNode.key,
          objectId: data[0].key
        })
        return
      }
      this.$store.commit('setDepartment', null)
    }
  }
}
</script>
<style lang="scss" scoped>
.amdin_role_card{
  height: 152px;
  color: #152137;
}
</style>
